import React from "react";
import {ConfirmationModal} from "../../../confirmationModal/ConfirmationModal";

interface ConfirmationModalProps {
    handleClose: (value?: any) => any;
    onConfirm: () => void | Promise<void>;
}

export const DeleteKnowledgeRecordConfirmationModal: React.FC<ConfirmationModalProps> = ({
                                                                                             handleClose,
                                                                                             onConfirm
                                                                                         }) => {
    const handleDelete = async () => {
        await onConfirm();
        handleClose();
    }

    return <ConfirmationModal
        title={"Delete knowledge record"}
        subtitle={"Are you sure you want to delete this knowledge record? You won't be able to undo this action."}
        closeButtonTitle={"No, cancel"}
        confirmButtonTitle={"Yes, delete"}
        onConfirm={handleDelete}
        onClose={handleClose}
    />
}
